<template>
  <div id="pdf-sidebar" class="detail-height">
    <div class="h-full">
      <VuePerfectScrollbar class="scroll-area--customizer pt-2 pb-2" :settings="settings">
        <!-- Pdf Header -->
        <div class="pdf-viewer">
          <header>
            <slot name="header"></slot>
          </header>
        </div>
        <!-- /Pdf Header -->
        <PDFDocument
          :isConsulting="isConsulting"
          :isNews="isNews"
          :dataId="dataId"
          :scale="scale"
          :url="url"
          :isMaximized="isMaximized"
          @updateScaleDocumentEvent="updateScaleViewer"
          @maximize="onMaximize"
        />
      </VuePerfectScrollbar>
    </div>

    <!-- Customizer Content -->
    <!-- <vs-sidebar hidden-background position-right v-model="active" class="items-no-padding"></vs-sidebar> -->
  </div>
</template>


<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import PDFDocument from "./pdf/PDFDocument";
import floor from "../../../helpers/floor";

export default {
  props: {
    url: String,
    dataId: String,
    title: String,
    isMaximized: Boolean,
    scale: Number,
    isConsulting: Boolean,
    isNews: Boolean
  },
  data() {
    return {
      active: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    };
  },
  components: {
    VuePerfectScrollbar,
    PDFDocument
  },
  watch: {
    scale(val) {
      // console.log('[change scale] ', val)
    }
  },
  methods: {
    onMaximize() {
      console.log('onMaximize', this.isMaximized);
      if (!this.isMaximized) {
        this.$emit('maximize', true);
      }
    },
    updateScaleViewer(scale) {
      console.log('updateScaleViewer');
      console.log(scale);
      this.$emit("updateScaleViewerEvent", scale);
    },
  }
};
</script>

<style lang="scss">
// .detail-height {
//   height: 580px;

//   .scroll-area--customizer {
//     height: calc(100% - -1.5rem);
//   }
// }
#pdf-sidebar {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 100%;
    max-width: 90vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
}

.scroll-area--customizer {
  height: calc(100% - 5rem);
  border-radius: 8px;
}

header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
}

.pdf-toolbar {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 4px;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
}

.header-item {
  // margin: 0.25em 2.5em;
}

@media print {
  header {
    display: none;
  }
}
</style>
